import { AwsRum } from 'aws-rum-web';
import { getConfig } from '../api.js';

/**
    This is for sending user browser statistics: http, errors, and performance to AWS CloudWatch RUM and is configured
    by reading AWS_RUM_* environment variables.

    You can reference the env vars within the docker/env_vars.json.template file. These are passed in from Helm rather
    than being hardcoded here. You can find these config options here:

    https://github.com/WeeverApps/ops-helm-deployment/blob/master/aws-rum/charts/inspections-manager/values.yaml

    AWS RUM ref: https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch-RUM.html
    agent config options: https://github.com/aws-observability/aws-rum-web/blob/main/docs/configuration.md
*/
export const initAwsRum = async (appSlug) => {
    const orchestratorConfig = await getConfig();
    /*
        if we choose to export the AwsRum agent initialized below, we may want to initialize it as null here
        so that the agent will not be undefined if AWS_RUM_ENABLED is false. exporting may be useful if we want to pass
        the agent around and log custom events to AWS Rum we can filter metrics on

        let awsRum = null;
    */
    if (orchestratorConfig.data.AWS_RUM_ENABLED === 'true') {
        try {
            const endpoint = `https://dataplane.rum.${orchestratorConfig.data.AWS_RUM_REGION}.amazonaws.com`;

            const config = {
                sessionSampleRate: parseFloat(orchestratorConfig.data.AWS_RUM_SAMPLE_RATE),
                guestRoleArn: orchestratorConfig.data.AWS_RUM_GUEST_ROLE_ARN,
                identityPoolId: orchestratorConfig.data.AWS_RUM_IDENTITY_POOL_ID,
                endpoint: endpoint,
                // format environment variable from [val1 val2 val3] to a proper array: ["val1","val2","val3"]
                telemetries: (orchestratorConfig.data.AWS_RUM_TELEMETRIES
                    .match(/\[(.*)\]/)[1] // extract values between square brackets
                    .split(' ') // split by spaces
                    .map(str => str.trim()) // remove leading/trailing spaces (if any)
                ),
                allowCookies: Boolean(orchestratorConfig.data.AWS_RUM_ALLOW_COOKIES),
                enableXRay: Boolean(orchestratorConfig.data.AWS_RUM_ENABLE_XRAY),
                // custom attributes added here which are included in every request sent to AWS RUM, we can filter
                // all metrics in the AWS Console with these
                sessionAttributes: {
                    appSlug: appSlug,
                    appVersion: orchestratorConfig.data.APP_VERSION
                }
            };

            const APPLICATION_ID = orchestratorConfig.data.AWS_RUM_APP_ID;
            const APPLICATION_VERSION = orchestratorConfig.data.AWS_RUM_APP_VERSION;
            const APPLICATION_REGION = orchestratorConfig.data.AWS_RUM_REGION;

            // to-do: add export of this for sending custom events to AWS RUM;, example: awsConfig = new AwsRum(<config>)
            new AwsRum(
                APPLICATION_ID,
                APPLICATION_VERSION,
                APPLICATION_REGION,
                config
            );

        } catch (error) {
            /*
                we can optionally add some error handling here in the event the rum agent fails to initialize
                for now we're intentionally not doing anything including logging the error out to the browser console
            */
        }
    }
};
